







import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GLoading from '@/components/GLoading.vue';
import { JgrowEventLikertScale } from '@/models/jgrow/jgrow-event-likert-scale';
import { JgrowEventLikertScaleItem } from '@/models/jgrow/jgrow-event-likert-scale-item';
import { JgrowEventLikertScaleAnalysis } from '@/models/jgrow/jgrow-event-likert-scale-analysis';
import { JgrowEventLikertScaleAnswer } from '@/models/jgrow/jgrow-event-likert-scale-answer';

@Component({
  name: 'GSurveyChartLikert',
  components: { GLoading },
})
export default class GSurveyChartLikert extends mixins(GPageBase) {
  @Prop() likertScale: JgrowEventLikertScale;
  @Prop() totalUserCount: number;

  mounted() {}

  get options(): any {
    const lastIndex = this.likertScale.items.length + 1;
    // リッカート尺度の設問に対する選択肢を、{選択肢のvalue : 選択肢Class（JgrowEventLikertScaleAnalysis）} のマップにする
    const selectItemMap = new Map(this.likertScale.items.sort((a, b: JgrowEventLikertScaleItem ) => a.value - b.value).map((jelsi: JgrowEventLikertScaleItem) => [jelsi.value, new JgrowEventLikertScaleAnalysis().deserialize(jelsi)]));
    // 未回答の数 => 受検者総数 - 回答数
    const notAnswerdCount = this.totalUserCount - this.likertScale.answers.length;
    // 未回答は API 側では管理していない。グラフの表示に必要な「未回答」という選択肢を画面側で生成する
    const notAnswerd = new JgrowEventLikertScaleItem();
    notAnswerd.title = '未回答';
    notAnswerd.value = lastIndex;
    selectItemMap.set(lastIndex, new JgrowEventLikertScaleAnalysis().deserialize(notAnswerd));
    // 未回答の数をセット
    selectItemMap.get(lastIndex).count = notAnswerdCount;    

    // 全回答で回って、それぞれの選択肢の選択された数をカウントアップしていく
    this.likertScale.answers.forEach((ans: JgrowEventLikertScaleAnswer) => {
      const value = ans.value;
      const item = selectItemMap.get(value);
      item.count++;
    });

    // 選択肢ごとに series にする
    const series: any = [];
    selectItemMap.forEach((analysis: JgrowEventLikertScaleAnalysis, key: number) => {
      series.push({
          name: analysis.title,
          type: 'bar',
          barWidth: 48,
          stack: 'total',
          label: {
            show: true,
            formatter: () => analysis.count + '人'  // 実数を表示
          },
          emphasis: {
            focus: 'series'
          },
          data: [analysis.getPercentByTotal(this.totalUserCount)]
        })
    });

    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        bottom: '0',
      },
      xAxis: {
        type: 'value',
        max: 100,
        show: false
      },
      yAxis: {
        type: 'category'
      },
      series: series
    };
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }
}
